/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { Card } from "../../UI/Card/Card";
import {useEffect, useRef, useState} from 'react'
import clsx from "clsx";
import OTPInput, {} from "otp-input-react";
import CustomToast from "../../UI/customToast";
import PropTypes from 'prop-types';
import __ from "lodash";
import parse from 'html-react-parser';
import PublicVariables from "../../../constants/PublicVariables";
import { afterLoginProcess, handleErrorMsgToastVisiblity } from "../../../shared/utility";

const Authy = (props) => {
    const [otp, setOtp] = useState('');
    const [isResendCodeDisable, setIsResendCodeDisable] = useState(false);
    const toastRef = useRef(null);
    const otpGroupRef = useRef(null);
    
    const handleOtpValueChange = (value) => {
        const replaceData = value?.replace('-', '')?.trim();
        setOtp(replaceData);
        if(replaceData.length === 6){
            toastRef.current = CustomToast.info(props.localisedValues['validating_code']);
            props.verifyOTP({verificationId:props.verificationId,uemail:PublicVariables.uEmailOnLogin, code: replaceData});
        }
    };

    useEffect(()=>{
        if (props?.login?.resendOtpLoading) {
            setIsResendCodeDisable(true)
        }
    },[props?.login?.resendOtpLoading]);

    useEffect(()=>{
        if(props?.login?.resendOtpData){
            CustomToast.success(props.localisedValues['ccod_resend_text']);
            setIsResendCodeDisable(false)
        }
    },[props?.login?.resendOtpData]);

    useEffect(() => {
        if (props?.login?.resendOtpError) {
            setIsResendCodeDisable(false)
        }
    }, [props?.login?.resendOtpError]);

    const handle = (e) => {
        /* the session has shut down */
        let clipboardData, pastedData;
        // Stop data actually being pasted into div
        e.stopPropagation();
        e.preventDefault();
        // Get pasted data via clipboard API
        clipboardData = e.clipboardData || window.clipboardData;
        pastedData = clipboardData.getData('Text');
        const replaceData = pastedData.replace('-', '');
        handleOtpValueChange(replaceData)
        const a =document.getElementsByClassName('otp-frm');
        a[0].lastChild.focus();
    }

    useEffect(() => {
        document.addEventListener("paste", handle, false);
        return () => {
            document.removeEventListener("paste", handle);
        }
    }, []);

    // otp-input-react renders 6 inputs with no per-input accessible names.
    // Label each one via the localized `otp_digit` template and add an inputmode
    // hint so screen readers announce meaningful field context.
    useEffect(() => {
        const groupEl = otpGroupRef.current;
        if (!groupEl) return;
        const inputs = groupEl.querySelectorAll('input');
        const template = props.localisedValues?.otp_digit || 'Digit {index} of {total}';
        inputs.forEach((input, idx) => {
            const label = template.replace('{index}', idx + 1).replace('{total}', inputs.length);
            input.setAttribute('aria-label', label);
            input.setAttribute('inputmode', 'numeric');
            input.setAttribute('autocomplete', 'one-time-code');
        });
    }, [props.localisedValues]);

    useEffect(() => {
        if (props?.login?.verifyOtpLoading) {
            setIsResendCodeDisable(true)
        }
        if (props?.login?.verifyOtpData) {
            if(toastRef.current) CustomToast.dismissToast(toastRef.current);
            setIsResendCodeDisable(false);
            afterLoginProcess(props?.login?.verifyOtpData);
        }
        if (props?.login?.verifyOtpError) {
            console.log(props?.login?.verifyOtpError.message);
            handleErrorMsgToastVisiblity(props?.login?.verifyOtpError.message);
            setIsResendCodeDisable(false)
            setOtp('');
            const a =document.getElementsByClassName('otp-frm')
            a[0].firstChild.focus()
        }
    }, [props?.login?.verifyOtpLoading, props?.login?.verifyOtpData, props?.login?.verifyOtpError]);

    const resendOtpFun = () => {
        props.resendOTP({verificationId:props.verificationId,uemail:PublicVariables.uEmailOnLogin});
    }
    return (
		<div className="login-section-box login-otp-box">
			<div className="login-section-in">
                <div className="signup-out-box">
                    <Card>
                        <div className="signup-in-scroll custom-scroll-div">
                            <div className="login-logo-subtext text-center">
                                <h2 data-testid="authytext">{props.localisedValues['check_ccode_text']}</h2>
                                <p>{parse(__.replace(props.localisedValues['ccod_genral_text'], '<trial_email>', PublicVariables.uEmailOnLogin))}</p>
                            </div>
                            <div className="form-group">
                                <span id="authy-otp-label" className="form-label verify-otp-label">{parse(props.localisedValues['your_ccode_text'])}</span>
                                <div
                                    className="verification-form"
                                    ref={otpGroupRef}
                                    role="group"
                                    aria-labelledby="authy-otp-label"
                                >
                                    <OTPInput
                                        className="otp-frm"
                                        otpType="number"
                                        value={otp}
                                        onChange={handleOtpValueChange}
                                        OTPLength={6}
                                        inputClassName="form-control form-control-grey"
                                    />
                                </div>
                            </div>
                            <div className="login-bottom-text">
                                <div className="have-an-account text-center"  data-testid="resendcodediv">
                                    {parse(props.localisedValues['ccode_note1_text'])} {!isResendCodeDisable ? <button type="button" className="btn-unstyled text-dec-none pointer" onClick={resendOtpFun}>{props.localisedValues['resend_code']}</button> : <button type="button" className={clsx('btn-unstyled text-dec-none', isResendCodeDisable && 'disable')} disabled>{props.localisedValues['resend_code']}</button>}
                                </div>
                            </div>
                        </div>                      
                    </Card>
                </div>
			</div>
		</div>
    );
}

Authy.propTypes = {
    login: PropTypes.object,
    localisedValues: PropTypes.object,
    verifyOTP: PropTypes.func,
    resendOTP: PropTypes.func,
    verificationId: PropTypes.string
}

export default Authy;